import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { ApiService } from 'src/app/services/api.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loging = '';
  passwd = '';
  loading = false;
  txtlogspinner = '';

  constructor(
    private router: Router,
    private api: ApiService,
    private appComponent: AppComponent
  ) {
    this.appComponent.login = true;
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('token') && sessionStorage.getItem('usuario')) {
      window.location.replace('/salon');
      return;
    }

    if (sessionStorage.getItem('token') && !sessionStorage.getItem('usuario')) {
      sessionStorage.clear();
    }
  }

  IniciarSesion(): void {
    if (!this.loging || !this.passwd) {
      swal.fire('Datos requeridos', 'Ingresa usuario y contrasena.', 'warning');
      return;
    }

    this.loading = true;
    this.txtlogspinner = 'Validando acceso...';

    this.api.getIniciarSesion({
      p_loging: this.loging,
      p_passwd: this.passwd
    }).subscribe({
      next: (res: any) => {
        const user = this.normalizeLoginUser(res);
        const userId = String(user.id || user.usu_id || '');

        if (!userId) {
          this.loading = false;
          swal.fire('Acceso no valido', 'El backend valido la clave, pero no devolvio el ID del usuario.', 'error');
          return;
        }

        sessionStorage.setItem('token', res.token || 'salon-token');
        sessionStorage.setItem('usuario', userId);
        sessionStorage.setItem('usu_id', userId);
        sessionStorage.setItem('sstid', String(user.sst_id || 0));
        sessionStorage.setItem('usu_nomcom', user.name || user.usu_nomcom || user.usu_login || this.loging);
        sessionStorage.setItem('usu_nombre', user.name || user.usu_nombre || this.loging);
        sessionStorage.setItem('rol_nombre', user.rol_nombre || '');
        sessionStorage.setItem('objetosMenu', JSON.stringify([{ obj_enlace: 'salon', obj_nombre: 'Salon' }]));

        this.loading = false;
        window.location.replace('/salon');
      },
      error: (err) => {
        this.loading = false;
        const mensajeError =
          err && err.error && (err.error.mensaje || err.error.message)
            ? (err.error.mensaje || err.error.message)
            : 'No se pudo iniciar sesion';
        swal.fire('Acceso no valido', mensajeError, 'error');
      }
    });
  }

  private normalizeLoginUser(res: any): any {
    if (!res) {
      return {};
    }
    if (res.user) {
      return res.user;
    }
    if (Array.isArray(res) && res.length) {
      return res[0] || {};
    }
    if (res.data && res.data.user) {
      return res.data.user;
    }
    if (res.data && Array.isArray(res.data) && res.data.length) {
      return res.data[0] || {};
    }
    return res;
  }
}
